// @flow
import { compose } from 'recompose'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { createItemAuctionSelector } from './selectors'

const mapStateToProps = (state, props) => {
  const itemId = Number(props.match.params.id)
  const auction = createItemAuctionSelector(itemId)(state)
  return { itemId, auction }
}
const withItemAuctionData = connect(mapStateToProps, {})

const enhancer = compose(withRouter, withItemAuctionData)

export default enhancer



// WEBPACK FOOTER //
// ./src/services/item/withItemAuctionData.js